const numberFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

export default numberFormatter;
